<template>
    <div class="address-container row">
        <div>
            <div class="col-xs-12">


                <span @click="$emit('showCustomerAddressModal', false)" class="pull-right close-btn">
                    <i class="fa fa-times-circle fa-2x"></i>
                </span>

                <h4>{{ 'Add Billing Address'|trans }} </h4>
                <button class="btn btn-primary" @click="copyAddress">
                    <nl2br tag="span" :text="'Copy from intervention address'|trans" />
                </button>
            </div>

            <div class="col-xs-12">
                <label>{{ 'Company Name'|trans }}</label>
                <input class="form form-control" v-model="address.company_name">
            </div>

            <div class="col-xs-12">
                <label>{{ 'Vat'|trans }}</label>
                <input class="form form-control" v-model="address.vat">
            </div>

            <div class="col-xs-12">
                <ZoneSelector
                        v-bind:zoneId.sync="address.zone.id"
                        v-bind:countryCode="address.country_name">
                </ZoneSelector>
            </div>

            <div class="col-xs-12">
                <label>{{ 'Street'|trans }}</label>
                <input class="form form-control" v-model="address.street.value">
            </div>

            <div class="col-xs-12">
                <label>{{ 'Street Number'|trans }}</label>
                <input class="form form-control" v-model="address.number">
            </div>

            <div class="col-xs-12">
                <label>{{ 'Country Name'|trans }}</label>
                <CountriesSelect v-model="address.country_name"
                                 v-bind:firstOnList="['BE','FR','IT','NL','PT','ES']"></CountriesSelect>
            </div>

            <div class="col-xs-12">
                <label>{{ 'Country Vat'|trans }}</label>
                <CountriesSelect v-model="address.country_vat"
                                 v-bind:firstOnList="['BE','FR','IT','NL','PT','ES']"></CountriesSelect>
            </div>

            <div class="col-xs-12">
                <button class="btn btn-primary" @click="saveAddress" v-if="!saving" v-bind:disabled="!validationForm">
                    <nl2br tag="span" :text="'ADD NEW BILLING ADDRESS'|trans" />
                </button>
                <Spinner v-bind:title="'Saving Address Please Wait'|trans" v-if="saving"></Spinner>
            </div>
        </div>
    </div>
</template>


<script>
    import CountriesSelect from './CountriesSelect';
    import api from '../../modules/api';
    import Spinner from '../Spinner'
    //import Autocomplete from 'v-autocomplete'
    import ItemTemplate from './ItemTemplateAutocomplete'
    import ZoneSelector from '../Zone/ZoneSelector';

    export default {
        props: {
            value: null,
            document_disabled: Boolean
        },
        data: function () {
            return {
                template: ItemTemplate,
                input_address: '',
                items_addresses: [],
                saving:false,
                address_selected_object : null,
                address : {
                    id : null,
                    company_name: '',
                    vat: '',
                    street: {
                        value :''
                    },
                    number: '',
                    country_name: null,
                    country_vat: '',
                    address_type:'billing',
                    zone: {
                        id: null,
                    },
                }
            }
        },
        methods : {
            copyAddress(){
                //console.log(this.value.customerAddressIntervention);
                this.address_selected_object = this.getCurrentAddressSelected();
                this.address.company_name = this.value.lastname;
                this.address.street.value     = this.value.customerAddressIntervention.street;
                this.address.number       = this.value.customerAddressIntervention.number;
                this.address.zone     = this.value.customerAddressIntervention.zone;
                this.address.country_name   = this.value.customerAddressIntervention.zone.country;
            },
            async saveAddress(){
                this.saving= true;
                const response = await api.address.createNewBillingAddress(this.address, this.value.id);
                if(response.success){
                    this.address.id = response.address_id;
                    this.$emit('new_address', this.address);
                    this.$emit('showCustomerAddressModal', false);
                    this.saving= false;
                }
            },
            getCurrentAddressSelected() {
                return this.value.addressSelected;
                // console.log(this.value);
                // const address_id =  this.value.addressSelected.id;
                // //console.log(this.value.address_selected_id);
                // return this.value.address.find(function (address) {
                //     return address.id === address_id;
                // });
            },
            getLabel (item) {
                return item;
            },
            async updateItems (address_input_text) {
                 const result = await api.address.jobSearchAddress(address_input_text);
                this.items_addresses = result.streets;
                return this.items_addresses;
            }
        },
        computed : {
            validationForm(){
                if(
                    this.address.company_name !== ''
                    // &&
                    // this.address.vat !== ''
                    &&
                    this.address.zone.id !== null
                    &&
                    this.address.street !== ''
                    &&
                    this.address.number !== ''
                    &&
                    this.address.country_name !== null
                    // &&
                    // this.address.country_vat !==  ''
                ){
                    return true;
                }
                return false;
            }
        },
        components:{
            CountriesSelect,
            Spinner,
            ZoneSelector,
            //Autocomplete
        }
    }

</script>

<style scoped>

    .close-btn{
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
    }

    .address-container{
        background: white;
        border: 1px solid #9bb6d2;
        margin: 20px 0px;
    }

</style>

